import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Blacklist from "@/pages/blacklist/page";
import BlacklistDetail from "@/pages/blacklist/detail/page";
import Guides from "@/pages/guides/page";
import GuideDetail from "@/pages/guides/detail/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "blacklist", element: <Blacklist /> },
      { path: "blacklist/:id", element: <BlacklistDetail /> },
      { path: "guides", element: <Guides /> },
      { path: "guides/:id", element: <GuideDetail /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;